import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListFeatureFlagsResponse } from './list-feature-flags-response';
import { listFeatureFlagsResponseSchema } from './list-feature-flags-response';

export async function listFeatureFlagsApi(): Promise<
  IValidatedResponse<IListFeatureFlagsResponse>
> {
  return getRequest<IListFeatureFlagsResponse>({
    path: '/sys/feature-flags',
    schema: listFeatureFlagsResponseSchema,
  });
}
